import { Action as ActionType } from "@iva/store-utils";
import { Interpretation } from "#services/pilotService/types";
import { ErrorPayload, IoState } from "#store/types";

/*******************************************************************************
 * types and interfaces
 ******************************************************************************/

export type InterpretationsMap = { [key: number]: IoState<Interpretation> };

// State definition
export interface InterpretationState {
    readonly interpretations: InterpretationsMap;
    // readonly query: string;
    // readonly pending: number[];
    // readonly requestId: string;
    // readonly tableResults: IQueryTableResult[];
}

// Action types definition
export enum InterpretationIdentifiers {
    FETCH_FROM_SERVER_SUCCEEDED = "@@interpretations/CREATE", // result from a successful read!
    FETCH_FROM_SERVER_FAILED = "@@interpretations/FETCH_FAILED",
    FETCH_FROM_SERVER_STARTED = "@@interpretations/FETCH_STARTED",
    FETCH_LIST_STARTED = "@@interpretations/FETCH_LIST_STARTED",
    FETCH_LIST_FAILED = "@@interpretations/FETCH_LIST_FAILED",
    FETCH_LIST_SUCCEEDED = "@@interpretations/FETCH_LIST_SUCCEEDED",
}

// Actions definition
export type FetchInterpretationSucceededActionType = ActionType<
    InterpretationIdentifiers.FETCH_FROM_SERVER_SUCCEEDED,
    Interpretation
>;
export type FetchInterpretationFailedActionType = ActionType<
    InterpretationIdentifiers.FETCH_FROM_SERVER_FAILED,
    ErrorPayload
>;
export type FetchInterpretationStartedActionType = ActionType<
    InterpretationIdentifiers.FETCH_FROM_SERVER_STARTED,
    number
>;
export type FetchInterpretationListStartedActionType = ActionType<
    InterpretationIdentifiers.FETCH_LIST_STARTED,
    undefined
>;
export type FetchInterpretationListSucceededActionType = ActionType<
    InterpretationIdentifiers.FETCH_LIST_SUCCEEDED,
    undefined
>;
export type FetchInterpretationListFailedActionType = ActionType<
    InterpretationIdentifiers.FETCH_LIST_FAILED,
    undefined
>;
export type InterpretationActionTypes =
    | FetchInterpretationStartedActionType
    | FetchInterpretationSucceededActionType
    | FetchInterpretationFailedActionType
    | FetchInterpretationListStartedActionType
    | FetchInterpretationListSucceededActionType
    | FetchInterpretationListFailedActionType;
